import { render, staticRenderFns } from "./etienne-guigal.vue?vue&type=template&id=3f10a35a&scoped=true"
import script from "./etienne-guigal.vue?vue&type=script&lang=js"
export * from "./etienne-guigal.vue?vue&type=script&lang=js"
import style0 from "./etienne-guigal.vue?vue&type=style&index=0&id=3f10a35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10a35a",
  null
  
)

export default component.exports